import { createAuthorizedObjectUrl, normalizeAuthorizedDownloadUrl } from "@/utils/download"

const STATE_KEY = '__authorizedSrcState'

function revoke(el) {
  const state = el[STATE_KEY]
  if (state && state.revoke) state.revoke()
  el[STATE_KEY] = null
}

function getOptions(binding) {
  if (binding && binding.value && typeof binding.value === 'object') {
    return binding.value
  }

  return { src: binding && binding.value }
}

async function setAuthorizedSrc(el, binding) {
  const options = getOptions(binding)
  const src = normalizeAuthorizedDownloadUrl(options.src)
  const fallback = options.fallback || ''
  const previousState = el[STATE_KEY]

  if (previousState && previousState.src === src && previousState.fallback === fallback) return

  revoke(el)
  if (fallback) el.src = fallback
  if (!src) return

  const state = { src, fallback, cancelled: false, revoke: null }
  el[STATE_KEY] = state

  try {
    const objectUrl = await createAuthorizedObjectUrl(src)
    if (state.cancelled || el[STATE_KEY] !== state) {
      objectUrl.revoke()
      return
    }

    state.revoke = objectUrl.revoke
    el.src = objectUrl.objectUrl
  } catch (error) {
    console.log('authorized_src_error', {
      status: error && error.response && error.response.status,
    })
    if (fallback) el.src = fallback
    revoke(el)
  }
}

export default {
  inserted: setAuthorizedSrc,
  update: setAuthorizedSrc,
  unbind(el) {
    const state = el[STATE_KEY]
    if (state) state.cancelled = true
    revoke(el)
  },
}
